module.exports = __webpack_public_path__ + "static/chapeu-d0285ca5b0e7683d15b52e2da7b24033.png";